function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3766 11.7175H9.39862L8.32262 12.3865V13.2984L9.29847 12.7019H9.32404V16.0811H10.3766V11.7175ZM13.0117 16.1408C14.0281 16.1408 14.7056 15.5016 14.7056 14.6024C14.7056 13.7715 14.1261 13.1791 13.342 13.1791C12.9286 13.1791 12.5856 13.356 12.4407 13.5967H12.4151L12.5153 12.5676H14.4478V11.7175H11.6481L11.4585 14.0698L12.3896 14.2445C12.5067 14.0484 12.7496 13.927 13.0053 13.9291C13.4059 13.9291 13.6914 14.2125 13.6893 14.6323C13.6914 15.0499 13.4102 15.3311 13.0117 15.3311C12.6729 15.3311 12.3938 15.1202 12.3789 14.7984H11.3562C11.369 15.5825 12.0572 16.1408 13.0117 16.1408Z",
  xfill: "#333333"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4704 0.272214C10.8724 -0.106544 11.5053 -0.0877451 11.884 0.314202C12.2628 0.716148 12.244 1.34903 11.8421 1.72779L8.67595 4.71124L11.7846 7.22206C12.2142 7.56908 12.2812 8.1987 11.9342 8.62834C11.5872 9.05799 10.9576 9.12496 10.5279 8.77794L6.70618 5.69116C6.14042 5.2342 6.10794 4.38304 6.63723 3.88429L10.4704 0.272214ZM12.499 3.60018C11.9491 3.54964 11.5 4.00222 11.5 4.55451C11.5 5.10679 11.9497 5.5485 12.4985 5.61029C16.7613 6.09026 20 9.60615 20 13.7772C20 18.2684 16.2452 22 11.5 22C6.75479 22 3 18.2684 3 13.7772C3 12.3079 3.4019 10.9199 4.10888 9.7172C4.50875 9.03698 4.06598 8.02763 3.27693 8.02763C2.98863 8.02763 2.71623 8.1669 2.56172 8.4103C1.57148 9.97021 1 11.8088 1 13.7772C1 19.4231 5.70101 24 11.5 24C17.299 24 22 19.4231 22 13.7772C22 8.45944 17.8294 4.09 12.499 3.60018Z",
  xfill: "#333333"
});

var SvgSkipBack = function SvgSkipBack(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "none",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSkipBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SkipBack.05443454.svg";
export { ForwardRef as ReactComponent };